// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2ehTx","insightsList":"newBusinessInsightsMenu_insightsList__2uX0N","active":"newBusinessInsightsMenu_active__Ja3qX"};